<template>
  <!-- <div :class="modalTheme"> -->
<div :class="userStore.filterClass">
    <h6 v-if="AreIdsShown" style="background: transparent; color: yellow">
      currentSelectedWorkSummaryWidget{{ workListStore.currentSelectedWorkSummaryWidget.id }} {{ workListStore.currentSelectedWorkSummaryWidget.name }}
    </h6>
    <!-- <h6 v-if="AreIdsShown">selectedFileName {{ selectedFileName }}</h6> -->

    <div style="background: transparent; padding: 0px">
      <h4 style="color: red" v-if="AreIdsShown" v-b-toggle.widgetCharts>Chart</h4>

      <WidgetFilters
        :selectedTaskFilters="workListStore.currentSelectedWorkSummaryWidget.selectedTaskTypeFilters"
        :workTaskFilters="workListStore.currentSelectedWorkSummaryWidget.widgetTaskTypeFilterItems"
        @selectedFilters="setWorkFilters"
        @eventA="emitRunEventA"
        @eventB="emitRunEventB"
      />
      <!-- <h2>???WidgetPriorityFiltersWork</h2> -->
      <!-- <WidgetPriorityFiltersWork v-if="workListStore.currentSelectedWorkSummaryWidget.dueTextSummary.length > 0" /> -->
        <WidgetDoughnutChart
          v-if="workListStore.currentSelectedWorkSummaryWidget.widgetType === 0"
          :widgetType="workListStore.currentSelectedWorkSummaryWidget.widgetType"
          :widget="workListStore.currentSelectedWorkSummaryWidget"
          :widgetDetail="workListStore.currentSelectedWorkSummaryWidget.dueTextSummary"
        />

        <WidgetPieChart
          v-if="workListStore.currentSelectedWorkSummaryWidget.widgetType === 1"
          :widgetType="workListStore.currentSelectedWorkSummaryWidget.widgetType"
          :widget="workListStore.currentSelectedWorkSummaryWidget"
          :widgetDetail="workListStore.currentSelectedWorkSummaryWidget.dueTextSummary"
        />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed, toRaw } from "vue";
// * STOREs
import { useStoreUser } from "@/stores/userStore";
const userStore = useStoreUser();

import { useStoreWorkList } from "@/stores/workListsStore";
import WidgetFilters from "@/components/WidgetFilters.vue";
// import WidgetPriorityFiltersPrimary from "@/components/WidgetPriorityFiltersPrimary.vue";

import WidgetDoughnutChart from "./WidgetDoughnutChart.vue";
import WidgetPieChart from "./WidgetPieChart.vue";
import WidgetBarChart from "./WidgetBarChart.vue";

// import CollapseTransition from "@ivanv/vue-collapse-transition/src/CollapseTransition.vue";
import { CollapseTransition } from "@ivanv/vue-collapse-transition";

// * EMITTER
const emit = defineEmits(["doForceRender"]);

const workListStore = useStoreWorkList();

const modalTheme = computed(() => userStore.bModalTheme);

const AreIdsShown = ref(false);
const isOpen = ref(false); // closed by default

function setWorkFilters(filters) {
  // console.clear()
// console.log("   setWorkFilters     ..........................................     selWorkFilters");
// console.log("filters");
// console.log(filters);
// console.log(toRaw(filters));

  // console.clear()
// console.log("             selWorkFilters");
// console.log("filters");
// console.log(filters);

// console.log("workListStore.workWidgetSummaryList");
// console.log(workListStore.workWidgetSummaryList);

  const aSelectedTaskTypeFilters = workListStore.workWidgetSummaryList.filter((rec) => {
    const jsonArray = Array.from(Object.values(JSON.parse(rec))); // convert json to jsonobj to array
// console.log("        jsonArray");
// console.log(jsonArray);

// console.log(" >>>>>>>>>>>>>>>>   rec  ");
// console.log(JSON.parse(rec));
    // rec.selectedTaskTypeFilters.push = e
    if (JSON.parse(rec).id === workListStore.currentSelectedWorkSummaryWidget.id) {
      return (JSON.parse(rec).selectedTaskTypeFilters = filters.value);
    }
  });

// console.log("aSelectedTaskTypeFilters.selectedTaskTypeFilters  :  ");
// console.log(aSelectedTaskTypeFilters);

// console.log(" 										NEW EMITTER doForceRender");
  // this.$emit('doForceRender',	1)
  emit("doForceRender", 1);
}

function emitRunEventA() {
// console.log("function emitRunEventA()");
// console.log("	@eventA=RunEventA   no params 	");
}
function emitRunEventB(data) {
// console.log("function emitRunEventB()");
// console.log("data");
// console.log(data);
}
onMounted(() => {
// console.log("onMounted() :      WidgetSummary CONTAINER    WORK  >>>>");
});
</script>

<style lang="scss" scoped>
@import "./worklistStyling.scss";

#pie {
  height: 540px;
  background: #353535;
  color: lightgoldenrodyellow;
}

.custom-resizer {
  width: 100%;
  height: 400px;
}

.custom-resizer > .pane {
  text-align: left;
  padding: 15px;
  overflow: hidden;
  background: #eee;
  border: 1px solid #ccc;
}

.custom-resizer > .multipane-resizer {
  margin: 0;
  left: 0;
  position: relative;

  &:before {
    display: block;
    content: "";
    width: 3px;
    height: 40px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -20px;
    margin-left: -1.5px;
    border-left: 1px solid #ccc;
    border-right: 1px solid #ccc;
  }

  &:hover {
    &:before {
      border-color: #999;
    }
  }
}

.dx-toolbar .dx-toolbar-items-container {
  height: 0rem !important;
}

.scroll-container,
.scroll-area {
  //max-width: 150px;
  height: 45px * 2;
  max-height: 45px * 4;
  //font-size: 30px;32
}

.scroll-container {
  overflow: auto;
  scroll-snap-type: y mandatory;
}

.scroll-area {
  scroll-snap-align: start;
}

.detailsSlot {
  border: 3px solid transparent;
}

.scroll-container,
.scroll-area {
  margin: 0 auto;
}

.scroll-area {
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.scroll-area:nth-of-type(1) {
  background: #49b293;
}

.scroll-area:nth-of-type(2) {
  background: #c94e4b;
}

.scroll-area:nth-of-type(3) {
  background: #4cc1be;
}

.scroll-area:nth-of-type(4) {
  background: #8360a6;
}

h2 {
  color: red;
  background: #9aa99b;
  border-radius: 12.5px;
}

.multipane.foo.layout-v .multipane-resizer {
  margin: 0;
  left: 0;
  /* reset default styling */
  width: 15px;
  background: transparent;
}

.multipane.foo.layout-h .multipane-resizer {
  margin: 0;
  top: 0;
  /* reset default styling */
  height: 15px;
  background: blue;
}
</style>
